/* unplugin-vue-components disabled */import { render } from "./PermissionsComponent.vue?vue&type=template&id=1b2142fa&scoped=true"
import script from "./PermissionsComponent.vue?vue&type=script&lang=js"
export * from "./PermissionsComponent.vue?vue&type=script&lang=js"

import "./PermissionsComponent.vue?vue&type=style&index=0&id=1b2142fa&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b2142fa"]])

export default __exports__